import { Type } from 'class-transformer';
import {
  IsBooleanString,
  IsIn,
  IsInt,
  IsOptional,
  IsString,
  Max,
  MaxLength,
  Min,
} from 'class-validator';
import {
  DEADLINE_ASSIGNEE_ID_MAX_LENGTH,
  DEADLINE_BUCKETS,
  DEADLINE_DOMAIN_VALUES,
  DEFAULT_DEADLINES_PAGE_SIZE,
  type DeadlineBucket,
  type DeadlineDomainValue,
  MAX_DEADLINES_PAGE_SIZE,
} from './deadline.constants';
import { IsIsoDay } from './is-iso-day.decorator';

export class ListDeadlinesQueryDto {
  @IsOptional()
  @IsIn(DEADLINE_DOMAIN_VALUES)
  domain?: DeadlineDomainValue;

  @IsOptional()
  @IsString()
  documentTypeId?: string;

  /** Filtro che restringe la lista a una persona: mai un raggruppamento. */
  @IsOptional()
  @IsString()
  @MaxLength(DEADLINE_ASSIGNEE_ID_MAX_LENGTH)
  assigneeUserId?: string;

  @IsOptional()
  @IsIn(DEADLINE_BUCKETS)
  bucket?: DeadlineBucket;

  /** Testo libero su titolo e nome del tipo. */
  @IsOptional()
  @IsString()
  @MaxLength(100)
  q?: string;

  @IsOptional()
  @IsIsoDay()
  dueFrom?: string;

  @IsOptional()
  @IsIsoDay()
  dueTo?: string;

  /** `"true"`: solo righe archiviate; altrimenti solo attive. */
  @IsOptional()
  @IsBooleanString()
  archived?: string;

  /** `"true"`: solo "documenti attesi" (ciclo corrente senza file). */
  @IsOptional()
  @IsBooleanString()
  withoutDocument?: string;

  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  page?: number = 1;

  @IsOptional()
  @Type(() => Number)
  @IsInt()
  @Min(1)
  @Max(MAX_DEADLINES_PAGE_SIZE)
  pageSize?: number = DEFAULT_DEADLINES_PAGE_SIZE;
}
